import { render } from "./SearchChain.vue?vue&type=template&id=3872b958"
import script from "./SearchChain.vue?vue&type=script&lang=js"
export * from "./SearchChain.vue?vue&type=script&lang=js"
script.render = render

export default script